/**
 * Created by tom on 29/05/17.
 */
export class DataTable<T> {
	constructor(protected columns: string[], sortColumn: string) {
		this._sortColumn = sortColumn;
	}

	protected _sortColumn: string;
	protected cmpFns  = {};

	protected defaultCompareFn = (a: any, b: any) : number => {
		let flip = this._sortOrder != "ASC" ? -1 : 1;
		let aVal = a[this.sortColumn];
		let bVal = b[this.sortColumn];
		if (aVal !== undefined && bVal === undefined) {
			return -flip;
		}

		if (aVal === undefined && bVal !== undefined) {
			return flip;
		}

		if (aVal === undefined && bVal === undefined) {
			return 0;
		}

		return flip * (aVal < bVal ? -1 : (aVal > bVal ? 1 : 0));
	};

	set sortColumn(columnName: string) {
		let dirty = columnName != this._sortColumn;
		this._sortColumn = columnName;
		this.sortOrder = dirty ? "ASC" : (this.sortOrder == "ASC" ? "DESC" : "ASC");
		this.doSort();
	}
	get sortColumn() {
		return this._sortColumn;
	}

	protected _data : T[] = [];
	set data(data: T[]) {
		this._data = data;
		this.doSort();
	}

	get data() : T[] {
		return this._data;
	}

	protected _sortOrder : "ASC"|"DESC" = "ASC";
	set sortOrder(order: "ASC"|"DESC") {
		let dirty = order != this._sortOrder;
		this._sortOrder = order;

		if (dirty) this.doSort();
	}
	get sortOrder() : "ASC"|"DESC" {
		return this._sortOrder;
	}

	public setColumnCompareFn(columnName : string, compareFn : (a: any, b: any) => number) {
		this.cmpFns[columnName] = compareFn;
	}

	protected doSort() : T[] {
		if (!this._data) return [];
		let compareFn = this.defaultCompareFn;
		if (this.cmpFns[this.sortColumn]) {
			let flip = this._sortOrder != "ASC" ? -1 : 1;
			compareFn = (a: any, b: any) : number => {
				return flip * this.cmpFns[this.sortColumn](a[this.sortColumn], b[this.sortColumn]);
			}
		}

		return this._data.sort(compareFn);
	}
}